
// GreenSock Animation Platform (GSAP) for loading animation--Library
// https://greensock.com/gsap/
// gsap.to(target, { property: value, duration: time })
import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";
import gsap from "gsap";
import { reviews } from "./data";
import imagesLoaded from "imagesloaded";
import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar';

class DisableScrollPlugin extends ScrollbarPlugin {
static pluginName = 'disableScroll';

static defaultOptions = {
    direction: '',
};

transformDelta(delta) {
    if (this.options.direction) {
    delta[this.options.direction] = 0;
    }

    return { ...delta };
}
}

// load the plugin
Scrollbar.use(DisableScrollPlugin);


class AnchorPlugin extends ScrollbarPlugin {
static pluginName = 'anchor';

onHashChange = () => {
    this.jumpToHash(window.location.hash);
};

onClick = (event) => {
    const { target } = event;

    if (target.tagName !== 'A') {
        return;
    }

    const hash = target.getAttribute('href');

    if (!hash || hash.charAt(0) !== '#') {
        return;
    }

    this.jumpToHash(hash);
    };

jumpToHash = (hash) => {
    const { scrollbar } = this;

    if (!hash) {
        return;
    }

    // reset scrollTop
    scrollbar.containerEl.scrollTop = 0;

    scrollbar.scrollIntoView(document.querySelector(hash));
};

onInit() {
    this.jumpToHash(window.location.hash);

    window.addEventListener('hashchange', this.onHashChange);

    this.scrollbar.contentEl.addEventListener('click', this.onClick);
}

onDestory() {
    window.removeEventListener('hashchange', this.onHashChange);

    this.scrollbar.contentEl.removeEventListener('click', this.onClick);
    }
}

// usage
Scrollbar.use(AnchorPlugin);

// Prevent browser from restoring previous scroll position
history.scrollRestoration = 'manual';
window.scrollTo(0, 0);

const bar = document.querySelector('.loading__bar--inner');
const counter_num = document.querySelector('.loading__counter--number');
let assetsLoaded = false;
let progressComplete = false;
let postLoadWaitComplete = false;
let postLoadHoldStarted = false;
let spinnerTween;
let loaderFinished = false;
let lockedScrollY = 0;

const lockPageScroll = () => {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.width = '100%';
};

const unlockPageScroll = () => {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
};

lockPageScroll();

let pageSmoothScroll = null;

const initializeSmoothScroll = () => {
    let options = {
        damping: 0.1,
        alwaysShowTracks: true,
        plugins: {
            disableScroll: {
                direction: 'x',
            },
        },
    };

    let pageSmoothScroll = Scrollbar.init(document.body, options);
    pageSmoothScroll.track.xAxis.element.remove();

    const scrollTopBtn = document.querySelector('.scrollTop');
    if (scrollTopBtn) {
        pageSmoothScroll.addListener(({ offset }) => {
            if (offset.y > 300) {
                scrollTopBtn.classList.add('visible');
            } else {
                scrollTopBtn.classList.remove('visible');
            }
        });
    }

};


const startPostLoadHold = () => {
    if (postLoadHoldStarted || !assetsLoaded || !progressComplete) {
        return;
    }

    postLoadHoldStarted = true;
    setTimeout(() => {
        postLoadWaitComplete = true;
        finishLoader();
    }, 600);
};

const finishLoader = () => {
    if (loaderFinished || !assetsLoaded || !progressComplete || !postLoadWaitComplete) {
        return;
    }

    loaderFinished = true;
    unlockPageScroll();

    if (spinnerTween) {
        spinnerTween.kill();
        gsap.to('.loading__svg', {
            duration: 12, // Slow down the spinner rotation for a smooth finish
            rotation: '+=360',
            ease: 'none',
            repeat: -1,
        });
    }

    gsap.to('.loading__box', {
        duration: 0.6,
        borderColor: 'transparent',
        borderWidth: 0,
    });

    gsap.to('.loading', {
        duration: 0.8,
        background: 'transparent',
        opacity: 0.35,
        pointerEvents: 'none',
        onComplete: () => {
            const loader = document.querySelector('.loading');

            if (loader) {
                loader.style.zIndex = '1';
            }
        }
    });

    gsap.to('header', {
        duration: 1,
        top: '0',
    });

    const isShortLandscape = window.matchMedia('(orientation: landscape) and (max-height: 520px)').matches;

    gsap.to('.socials', {
        duration: 1,
        delay: 0.5,
        bottom: isShortLandscape ? '4.5rem' : '10rem',
    });

    gsap.to('.scrollDown', {
        duration: 1,
        delay: 0.8,
        bottom: isShortLandscape ? '1rem' : '3rem',
    });

    initializeSmoothScroll();
};

const watchImages = () => {
    imagesLoaded(document.body, { background: true }, () => {
        assetsLoaded = true;
        startPostLoadHold();
        finishLoader();
    });
};

let c = 0;

let barInterval = setInterval(() => { 
    bar.style.width = c + `%`;
    counter_num.textContent = c + `%`;
    c++;
    if(c > 100) {
    clearInterval(barInterval);
    progressComplete = true;
    startPostLoadHold();
    finishLoader();
    gsap.to('.loading__bar', {
    duration: 0.7,
    ease: 'power2.inOut',
    rotate: "90deg",
    left: "220%",
    opacity: 0,
    onComplete: () => {
        gsap.set('.loading__bar', { display: 'none' });
    },

}); 
gsap.to('.loading__text,.loading__counter', {
    duration: 0.5,
    opacity: 0,

});
gsap.to('.loading__box', {
    duration: 1,
    height: "500px",
    borderRadius: "50%",

});
gsap.to('.loading__svg', {
    duration: 0.4,
    opacity: 1,
    scale: 1,

});
    spinnerTween = gsap.to('.loading__svg', {
        duration: 2.6,
        rotation: '+=360',
        ease: 'none',
        repeat: -1,
    });

}

    // This will determine the speed of the counter(0-100%) and progress bar
}, 1);

// inserting reviews data into the reviews section
const swiper_container = document.querySelector('.swiper-wrapper');
reviews.map((review) => {
    const template = `<div class="swiper-slide"><div class="review"><svg width="33" height="27" viewBox="0 0 33 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.999961 20.2398C0.91996 19.0398 0.959962 17.6398 1.11996 16.0398C1.35996 14.3598 2.27997 11.9198 3.87996 8.71984C5.55996 5.43984 7.43996 2.91984 9.51996 1.15984L13.12 3.43984C11.68 5.27984 10.6 7.27984 9.87996 9.43984C9.23996 11.5198 8.87996 13.3998 8.79996 15.0798C9.63996 15.0798 10.48 15.1998 11.32 15.4398C12.24 15.5998 13.04 15.9598 13.72 16.5198C14.48 17.0798 15.08 17.7998 15.52 18.6798C16.04 19.4798 16.3 20.5198 16.3 21.7998C16.3 23.0798 16 24.1598 15.4 25.0398C14.88 25.8398 14.2 26.4798 13.36 26.9598C12.6 27.3598 11.72 27.5598 10.72 27.5598C9.63996 27.5598 8.67996 27.2798 7.83996 26.7198C7.07996 26.0798 6.47996 25.2798 6.03996 24.3198C5.59996 23.2798 5.37996 22.1598 5.37996 20.9598C5.37996 20.7198 5.37996 20.4798 5.37996 20.2398H0.999961ZM17.5 20.2398C17.42 19.0398 17.46 17.6398 17.62 16.0398C17.86 14.3598 18.78 11.9198 20.38 8.71984C22.06 5.43984 23.94 2.91984 26.02 1.15984L29.5 3.43984C28.06 5.27984 26.98 7.27984 26.26 9.43984C25.62 11.5198 25.26 13.3998 25.18 15.0798C26.02 15.0798 26.9 15.1998 27.82 15.4398C28.74 15.5998 29.54 15.9598 30.22 16.5198C30.98 17.0798 31.58 17.7998 32.02 18.6798C32.54 19.4798 32.8 20.5198 32.8 21.7998C32.8 23.0798 32.5 24.1598 31.9 25.0398C31.38 25.8398 30.7 26.4798 29.86 26.9598C29.1 27.3598 28.22 27.5598 27.22 27.5598C26.14 27.5598 25.18 27.2798 24.34 26.7198C23.58 26.0798 22.98 25.2798 22.54 24.3198C22.1 23.2798 21.88 22.1598 21.88 20.9598C21.88 20.7198 21.88 20.4798 21.88 20.2398H17.5Z" fill="#f44336"/></svg><div class="review__card"><div class="review__topborder"></div><div class="review__text"><span>${review.review.substring(0, 1)}</span>${review.review.substring(1, review.review.length)}</div><img src="${review.image}" alt="" class="review__img"><div class="review__profile"><span>${review.name}</span><span>${review.position}</span></div></div></div></div>`;
    swiper_container.innerHTML += template;
});

watchImages();

// reviews swiper/slideshow initialization - AFTER adding the content
var swiper = new Swiper(".swiper", {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        640: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 50,
        },
    },
});

const questions = [...document.querySelectorAll('.question')];
questions.map((question) => {
    let q_text = question.querySelector('h3');
    let q_button = question.querySelector('.question__statusRButton');
    
    const toggleQuestion = () => {
        questions.filter((q) => q !== question).map((q) => q.classList.remove('open'));
        question.classList.toggle('open');
    };
    
    q_text.addEventListener('click', toggleQuestion);
    q_button.addEventListener('click', toggleQuestion);
});

// Automatic change tracking with HMR
if (module.hot) {
module.hot.accept(() => {
    const changedFiles = module.hot.data?.changedFiles || [];
    
    // Get file name from module path
    const modulePath = module.id || 'unknown';
    const fileName = modulePath.split('/').pop() || modulePath.split('\\').pop() || 'styles/scripts';
    
    // Log change to localStorage
    const changeHistory = JSON.parse(localStorage.getItem('changeHistory') || '[]');
    const now = new Date();
    
    changeHistory.push({
    time: now.toLocaleTimeString(),
    files: fileName,
    description: `Hot Module Replacement: ${fileName} was updated`,
    type: 'HMR',
    timestamp: now.getTime()
    });
    
    // Keep only last 20
    if (changeHistory.length > 20) {
    changeHistory.shift();
    }
    
    localStorage.setItem('changeHistory', JSON.stringify(changeHistory));
    
    // Show notification
    const toast = document.createElement('div');
    toast.textContent = `✓ ${fileName} updated`;
    toast.style.cssText = 'position:fixed;top:20px;right:20px;background:#28a745;color:white;padding:12px 20px;border-radius:5px;z-index:10000;font-family:sans-serif;box-shadow:0 2px 5px rgba(0,0,0,0.2);animation:slideIn 0.3s ease;';
    document.body.appendChild(toast);
    setTimeout(() => {
    toast.style.animation = 'slideOut 0.3s ease';
    setTimeout(() => toast.remove(), 300);
    }, 2000);
});
}
